import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  propertiesContainer: {
    height: '100%',
    position: 'relative',

    marginTop: 16
  },

  propertiesDivider: {
    width: '100%'
  },

  propertiesTableActions: {
    width: '100%',
    display: 'flex',
    height: 5,
    '& img': {
      cursor: 'pointer'
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-around'
    }
  },

  propertiesHeader: {
    width: '100%',
    gap: 8,
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      display: 'inline-flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },

  propertiesTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight
  },

  propertiesButtonContainer: {
    marginLeft: 'auto',
    width: '100%',
    '& h1': {
      margin: '0 16px 0 0',
      cursor: 'pointer'
    },
    '@media (min-width:356px)': {
      width: 'unset',
      '& button': {
        width: 146,
        margin: '0 16px 0 0',
        '& img': {
          marginRight: 8
        }
      }
    }
  },

  propertiesPopup: {
    '& .popup__box': {
      height: 'auto'
    }
  },

  customButtonWrapper: {
    width: 'auto'
  },

  buttonContainer: {
    display: 'flex',
    gap: '10px',

    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      marginTop: '8px',
      flexDirection: 'column',
      width: '100%'
    }
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px',
    height: 40,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    backgroundColor: theme.palette.primary.main,
    border: 'none',
    color: theme.palette.text.primary,
    fontWeight: 600,
    textDecoration: 'none',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  usersPopup: {}
}))
